import {
  Switch as BlueprintSwitch,
  SwitchProps as BlueprintSwitchProps,
} from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

export type ToggleProps = Omit<
  BlueprintSwitchProps,
  | 'alignIndicator'
  | 'defaultChecked'
  | 'inline'
  | 'innerLabel'
  | 'innerLabelChecked'
  | 'label'
  | 'labelElement'
  | 'large'
  | 'size'
> & {
  'data-testid'?: never;
  invalid?: boolean;
  size: 'md' | 'sm';
  testId?: string;
};

export const Toggle: React.VFC<ToggleProps> = ({
  checked = false,
  children,
  className,
  invalid,
  size,
  testId,
  ...props
}) => (
  <BlueprintSwitch
    checked={checked}
    className={classNames(className, 'vb-toggle', `vb-toggle-size--${size}`, {
      'vb-toggle-state--invalid': invalid,
    })}
    data-testid={testId}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
  </BlueprintSwitch>
);
